// DON't forget update index.html after update types!
interface IAppEnv {
  SENTRY_DSN: string;
  REACT_APP_SENTRY_DSN: string;
  NODE_ENV: string;
  RELEASE_VERSION: string;
  REACT_APP_RELEASE_VERSION: string;
  REACT_APP_CIR_ENABLED: string;
}

const devEnv: IAppEnv = {
  NODE_ENV: import.meta.env.MODE,
  SENTRY_DSN: '',
  REACT_APP_SENTRY_DSN: import.meta.env.REACT_APP_SENTRY_DSN ?? '',
  RELEASE_VERSION: '',
  REACT_APP_RELEASE_VERSION: import.meta.env.REACT_APP_RELEASE_VERSION ?? '',
  REACT_APP_CIR_ENABLED: import.meta.env.REACT_APP_CIR_ENABLED ?? ''
};

export const envConfig: IAppEnv = import.meta.env.DEV ? devEnv : (window as Window & { env: IAppEnv }).env;

export const isCirEnabled = envConfig.REACT_APP_CIR_ENABLED === 'true';

export const MANILA_TIMEZONE_OFFSET = '+08:00';
